var map = {
	"./af-ZA.json": "uUVx",
	"./ar-SA.json": "lUAg",
	"./bg-BG.json": "5Bkc",
	"./da-DK.json": "rhdu",
	"./de-DE.json": "vQ0A",
	"./en-GB.json": "b/l6",
	"./en-US.json": "QDRa",
	"./es-ES.json": "sXeN",
	"./et-ET.json": "vriI",
	"./fa-IR.json": "n1qB",
	"./fi-FI.json": "LpOI",
	"./fr-FR.json": "ESZ8",
	"./he-IL.json": "uJET",
	"./hr-HR.json": "aoC6",
	"./hu-HU.json": "Yjm8",
	"./id-ID.json": "Q/Ht",
	"./it-IT.json": "Lhui",
	"./ja-JP.json": "kAj5",
	"./ka-GE.json": "K9vJ",
	"./ko-KR.json": "+0Cn",
	"./nb-NO.json": "06qg",
	"./nl-NL.json": "zeDA",
	"./pt-BR.json": "Pfka",
	"./ru-RU.json": "KtA6",
	"./sv-SV.json": "5ygq",
	"./th-TH.json": "0DJb",
	"./tr-TR.json": "Kdpc",
	"./uk-UA.json": "fRYD",
	"./vi-VN.json": "cjyA",
	"./zh-CN.json": "gkDd",
	"./zh-TW.json": "DTCq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vGP0";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales \.json$
// module id = vGP0
// module chunks = 1